import { render, staticRenderFns } from "./Playcards.vue?vue&type=template&id=24a1c561&lang=pug"
import script from "./Playcards.vue?vue&type=script&lang=js"
export * from "./Playcards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports